// 导航吃瓜 · 首页共享内容数据（简体中文）
// 说明：本文件为门户静态内容目录数据，供首页各区块与顶部搜索共享使用。

export type Category = {
  id: string;
  name: string;
  en: string;
  icon: string;
  desc: string;
  count: string;
  tone: 'primary' | 'accent' | 'secondary';
  tags: string[];
};

export const categories: Category[] = [
  {
    id: 'movie',
    name: '影视瓜',
    en: 'Film & TV',
    icon: 'ri-movie-2-line',
    desc: '剧集热播、电影定档、选角传闻、幕后花絮，第一时间归类。',
    count: '1,286 条',
    tone: 'primary',
    tags: ['热播剧', '定档', '选角', '幕后', '收视'],
  },
  {
    id: 'show',
    name: '综艺现场',
    en: 'Variety',
    icon: 'ri-live-fill',
    desc: '名场面复盘、主持人互动、录制花絮与高光片段速览。',
    count: '968 条',
    tone: 'accent',
    tags: ['名场面', '录制花絮', '主持人', '飞行嘉宾'],
  },
  {
    id: 'star',
    name: '明星动态',
    en: 'Celebrities',
    icon: 'ri-user-star-line',
    desc: '明星行程、作品官宣、采访亮点与作品相关资讯追踪。',
    count: '2,041 条',
    tone: 'primary',
    tags: ['行程', '官宣', '采访', '红毯', '生日'],
  },
  {
    id: 'influencer',
    name: '网红圈',
    en: 'Influencer',
    icon: 'ri-user-heart-line',
    desc: '博主动态、团队变化、内容转型与网红生态观察。',
    count: '743 条',
    tone: 'secondary',
    tags: ['博主', '团队变动', '内容转型', 'MCN'],
  },
  {
    id: 'live',
    name: '直播热搜',
    en: 'Live',
    icon: 'ri-live-line',
    desc: '直播间名场面、节奏争议与主播高光时刻速递。',
    count: '856 条',
    tone: 'accent',
    tags: ['名场面', '直播间', '节奏', '带货'],
  },
  {
    id: 'music',
    name: '乐坛速递',
    en: 'Music',
    icon: 'ri-music-2-line',
    desc: '新歌发布、演唱会官宣、榜单更迭与音乐人动态。',
    count: '612 条',
    tone: 'primary',
    tags: ['新歌', '演唱会', '榜单', '音乐人'],
  },
  {
    id: 'esports',
    name: '电竞·游戏',
    en: 'Esports',
    icon: 'ri-gamepad-line',
    desc: '赛事赛果、战队转会、新游资讯与电竞趣闻盘点。',
    count: '527 条',
    tone: 'secondary',
    tags: ['赛事', '转会', '战队', '新游'],
  },
  {
    id: 'fashion',
    name: '时尚·红毯',
    en: 'Fashion',
    icon: 'ri-shirt-line',
    desc: '红毯造型、品牌看秀、穿搭盘点与时尚盛典现场。',
    count: '334 条',
    tone: 'accent',
    tags: ['红毯', '造型', '盛典', '街拍'],
  },
  {
    id: 'brand',
    name: '品牌·商业',
    en: 'Brands',
    icon: 'ri-briefcase-line',
    desc: '品牌代言官宣、联名企划与商业合作话题观察。',
    count: '298 条',
    tone: 'secondary',
    tags: ['代言', '联名', '品牌', '商业'],
  },
];

export type RankItem = {
  id: string;
  title: string;
  cat: string;
  catId: string;
  heat: string;
  time: string;
  trend: 'up' | 'down' | 'new';
  tags: string[];
};

export const hotRank: RankItem[] = [
  {
    id: 'rank-1',
    title: '《追光的人》大结局口碑反转，观众热议结局走向',
    cat: '影视瓜',
    catId: 'movie',
    heat: '128.6万',
    time: '12分钟前',
    trend: 'up',
    tags: ['热播剧', '大结局'],
  },
  {
    id: 'rank-2',
    title: '爆款综艺第五季官宣常驻名单，飞行嘉宾成悬念',
    cat: '综艺现场',
    catId: 'show',
    heat: '96.2万',
    time: '36分钟前',
    trend: 'up',
    tags: ['官宣', '常驻'],
  },
  {
    id: 'rank-3',
    title: '某音乐节官宣全阵容，多组艺人首次同台引期待',
    cat: '乐坛速递',
    catId: 'music',
    heat: '71.4万',
    time: '1小时前',
    trend: 'new',
    tags: ['音乐节', '官宣'],
  },
  {
    id: 'rank-4',
    title: '头部电商直播间新主播首秀，首场成交破纪录',
    cat: '直播热搜',
    catId: 'live',
    heat: '58.8万',
    time: '2小时前',
    trend: 'up',
    tags: ['直播间', '带货'],
  },
  {
    id: 'rank-5',
    title: '都市剧剧组官宣新阵容，选角话题登热搜',
    cat: '影视瓜',
    catId: 'movie',
    heat: '43.5万',
    time: '3小时前',
    trend: 'down',
    tags: ['选角', '官宣'],
  },
  {
    id: 'rank-6',
    title: '顶流电竞战队官宣重磅引援，夏季赛格局生变',
    cat: '电竞·游戏',
    catId: 'esports',
    heat: '39.1万',
    time: '4小时前',
    trend: 'up',
    tags: ['引援', '战队'],
  },
];

export type Topic = {
  id: string;
  name: string;
  kicker: string;
  desc: string;
  count: string;
  image: string;
  alt: string;
};

export const topics: Topic[] = [
  {
    id: 'topic-1',
    name: '年度热播剧追踪',
    kicker: '影视专题',
    desc: '把当季热度最高的剧集按题材、平台与更新节奏归类，追剧不断更。',
    count: '专题收录 32 部',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20film%20set%20with%20soft%20dramatic%20theater%20lighting%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20editorial%20composition%20with%20curtain%20and%20spotlight%2C%20muted%2C%20artistic%2C%20no%20text&width=1200&height=800&seq=navi-topic-drama&orientation=landscape', 
    alt: '年度热播剧追踪专题封面',
  },
  {
    id: 'topic-2',
    name: '爆款综艺幕后册',
    kicker: '综艺专题',
    desc: '从棚内录制到花絮复盘，按节目整理高光名场面与观众讨论脉络。',
    count: '专题收录 24 档',
    image: 'https://readdy.ai/api/search-image?query=colorful%20television%20studio%20stage%20with%20bright%20spotlights%2C%20vibrant%20but%20warm%20coral%20green%20and%20cream%20palette%2C%20abstract%20entertainment%20editorial%20art%2C%20soft%20glow%2C%20no%20text&width=1200&height=800&seq=navi-topic-show&orientation=landscape',
    alt: '爆款综艺幕后册专题封面',
  },
  {
    id: 'topic-3',
    name: '红毯造型图鉴',
    kicker: '时尚专题',
    desc: '按场合、品牌与风格维度整理盛典红毯造型，穿衣思路一键查阅。',
    count: '专题收录 18 场',
    image: 'https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20scene%20with%20warm%20lights%20and%20glamorous%20atmosphere%2C%20cream%20and%20coral%20and%20deep%20green%20palette%2C%20abstract%20fashion%20editorial%20background%2C%20soft%20bokeh%2C%20no%20text&width=1200&height=800&seq=navi-topic-fashion&orientation=landscape',
    alt: '红毯造型图鉴专题封面',
  },
  {
    id: 'topic-4',
    name: '乐坛新声季',
    kicker: '音乐专题',
    desc: '新歌、专辑与巡演动态汇总，按音乐人与风格检索乐坛新鲜事。',
    count: '专题收录 40 条',
    image: 'https://readdy.ai/api/search-image?query=lively%20music%20stage%20with%20warm%20coral%20and%20mint%20green%20lights%20and%20fog%2C%20concert%20atmosphere%2C%20abstract%20editorial%20music%20art%2C%20cream%20background%2C%20no%20text&width=1200&height=800&seq=navi-topic-music&orientation=landscape',
    alt: '乐坛新声季专题封面',
  },
];

export type ColumnItem = {
  id: string;
  name: string;
  host: string;
  icon: string;
  desc: string;
  freq: string;
  reads: string;
  tone: 'primary' | 'accent' | 'secondary';
};

export const columns: ColumnItem[] = [
  { id: 'col-1', name: '八卦速报', host: '瓜子铺', icon: 'ri-flashlight-fill', desc: '高频更新的短平快话题速报，碎片时间也能跟上节奏。', freq: '每日更新', reads: '12.8万', tone: 'primary' },
  { id: 'col-2', name: '深扒研究院', host: '吃瓜老编', icon: 'ri-search-eye-line', desc: '把热点还原成完整时间线，帮你理清来龙去脉。', freq: '每周 3 篇', reads: '8.4万', tone: 'accent' },
  { id: 'col-3', name: '红毯现场', host: '闪姐', icon: 'ri-camera-3-line', desc: '一线盛典直击，造型盘点与搭配解读都在这里。', freq: '随活动更新', reads: '5.2万', tone: 'secondary' },
  { id: 'col-4', name: '乐坛简报', host: '声波电台', icon: 'ri-disc-line', desc: '新歌、榜单与演出资讯一次打包，一周看遍乐坛。', freq: '每周一更', reads: '6.9万', tone: 'primary' },
  { id: 'col-5', name: '直播观察站', host: '场控小李', icon: 'ri-mic-2-line', desc: '拆解直播间节奏与看点，理性围观不跟风。', freq: '每周 2 篇', reads: '4.7万', tone: 'accent' },
  { id: 'col-6', name: '电竞前线', host: '峡谷侦探', icon: 'ri-game-line', desc: '赛事、转会与战队动态，赛场内外一并覆盖。', freq: '赛期高频', reads: '7.3万', tone: 'secondary' },
];

export type TagCloudItem = { label: string; weight: number };

export const tagCloud: TagCloudItem[] = [
  { label: '热播剧', weight: 92 },
  { label: '大结局', weight: 61 },
  { label: '红毯造型', weight: 74 },
  { label: '官宣阵容', weight: 70 },
  { label: '直播间', weight: 66 },
  { label: '新歌发布', weight: 58 },
  { label: '音乐节', weight: 52 },
  { label: '综艺名场面', weight: 81 },
  { label: '选角传闻', weight: 63 },
  { label: '战队引援', weight: 55 },
  { label: '联名企划', weight: 47 },
  { label: '幕后花絮', weight: 60 },
  { label: '采访亮点', weight: 43 },
  { label: '榜单更迭', weight: 49 },
  { label: '巡演官宣', weight: 44 },
  { label: '穿搭盘点', weight: 39 },
  { label: '盛典现场', weight: 42 },
  { label: '飞行嘉宾', weight: 51 },
];

export type UpdateItem = {
  id: string;
  title: string;
  cat: string;
  catId: string;
  time: string;
  read: string;
};

export const updates: UpdateItem[] = [
  { id: 'u-1', title: '新晋顶流官宣全新古装剧男主，搭档阵容同步释出', cat: '影视瓜', catId: 'movie', time: '今天 09:20', read: '18.2万' },
  { id: 'u-2', title: '头部 MCN 与知名主播续约，合作模式首度公开', cat: '网红圈', catId: 'influencer', time: '今天 08:45', read: '9.6万' },
  { id: 'u-3', title: '夏日音乐盛典公布首批阵容，多组新势力加盟', cat: '乐坛速递', catId: 'music', time: '昨天 22:10', read: '14.3万' },
  { id: 'u-4', title: '电竞联赛春季总决赛落幕，冠军战队锁定世界赛席位', cat: '电竞·游戏', catId: 'esports', time: '昨天 20:32', read: '21.5万' },
  { id: 'u-5', title: '顶流品牌与设计师联名系列首发，开售前预约破纪录', cat: '品牌·商业', catId: 'brand', time: '昨天 18:05', read: '7.8万' },
  { id: 'u-6', title: '一档全新推理综艺定档，嘉宾与赛制细节引发讨论', cat: '综艺现场', catId: 'show', time: '昨天 15:47', read: '11.9万' },
];

export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  {
    q: '导航吃瓜和普通娱乐网站有什么区别？',
    a: '导航吃瓜的核心是把散落在各处的吃瓜话题按分类、标签、专题、板块、栏目和目录重新整理成一张清晰索引。你不必在海量信息里大海捞针，先定位感兴趣的方向，再一键直达对应内容，查找效率更高。',
  },
  {
    q: '里面的“分类”“标签”“专题”“栏目”有什么不同？',
    a: '分类是最上层的索引，例如影视瓜、综艺现场、明星动态；标签用来标记单条话题的特征，例如大结局、官宣阵容；专题是把一类相关话题系统整理成册；栏目则是固定的更新频道，由编辑持续产出。四者层层递进，方便从不同角度检索。',
  },
  {
    q: '内容多久更新一次？',
    a: '高频速报类栏目基本保持每日更新，专题与深扒类内容按每周节奏稳定产出。首页“最新更新”区会实时展示最近收录的话题，方便你快速刷新时间线。',
  },
  {
    q: '热门话题为什么需要分类导航？',
    a: '热门话题通常来去很快，没有结构的堆砌很难回看与检索。导航吃瓜会把热点沉淀到对应分类与专题中，即便话题热度过去，你也能顺着分类和目录重新找到它，避免有价值的讨论被时间淹没。',
  },
  {
    q: '我可以在导航吃瓜里投稿或提收录建议吗？',
    a: '可以。欢迎通过页面底部的“收录建议与意见反馈”告诉我们你关注的栏目、专题或想看到的分类方向，我们会评估后纳入后续整理计划。',
  },
];

export const stats = [
  { value: '7,665', label: '已收录话题' },
  { value: '36', label: '常设栏目' },
  { value: '9', label: '内容分类' },
  { value: '128', label: '精品专题' },
];